import {
  TelegramPostPreview,
  PreviewMessageType,
} from 'components/common/TelegramPostPreview';
import type {
  PreviewWrapperProps,
  TMessageType,
  TPermittedState,
} from './PreviewWrapper.model';
import { useBroadcastStore } from 'store/broadcast/broadcast.store';
import { useTaskStore } from 'store/task/task.store';
import { useRecognitionStore } from 'store/recognition';

export const PreviewWrapper = <TState extends TPermittedState>({
  useStoreFunction,
  messageKey = 'description' as TMessageType,
  withPreviewMessages = false,
}: PreviewWrapperProps<TState>) => {
  const state = useStoreFunction((state) => state);

  let previewMessages = undefined;

  if (
    withPreviewMessages &&
    'errorMessage' in state.draft &&
    'successMessage' in state.draft
  ) {
    previewMessages = [
      {
        type: PreviewMessageType.ERROR,
        text: state.draft.errorMessage,
      },
      {
        type: PreviewMessageType.SUCCESS,
        text: state.draft.successMessage,
      },
    ];
  }

  return (
    <TelegramPostPreview
      attachments={state.draft.attachments}
      message={state.draft[messageKey]}
      title={state.draft.title}
      {...(withPreviewMessages && { previewMessages })}
    />
  );
};

export const BroadcastPreview = () => {
  return (
    <PreviewWrapper
      messageKey={'message' as TMessageType}
      useStoreFunction={useBroadcastStore}
    />
  );
};

export const TaskPreview = () => {
  return <PreviewWrapper withPreviewMessages useStoreFunction={useTaskStore} />;
};

export const RecognitionPreview = () => {
  return <PreviewWrapper useStoreFunction={useRecognitionStore} />;
};
